import React, { useEffect, useState } from "react";

import { FeedbackFormContext, FeedbackFormContextProps, FeedbackFormData } from "./feedback_form_context";

export const FeedbackFormContextProvider = ({
  children,
  onUpdate,
  defaultData
}: React.PropsWithChildren<FeedbackFormContextProps>) => {
  const [formData, setFormData] = useState<FeedbackFormData>();
  const [errors, setErrors] = useState<Record<number, string | string[]>>({});

  useEffect(() => {
    if (defaultData) {
      setFormData(defaultData);
    }
  }, [defaultData]);

  useEffect(() => {
    onUpdate?.(formData || null);
  }, [formData, onUpdate]);

  return (
    <FeedbackFormContext.Provider
      value={{
        setFormData,
        formData,
        errors,
        setErrors
      }}
    >
      {children}
    </FeedbackFormContext.Provider>
  );
};
